var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0075 9.535C12.085 9.535 11.1925 9.385 10.36 9.115C10.2296 9.07079 10.0893 9.06423 9.95536 9.09607C9.82139 9.1279 9.69909 9.19685 9.6025 9.295L8.425 10.7725C6.3025 9.76 4.315 7.8475 3.2575 5.65L4.72 4.405C4.9225 4.195 4.9825 3.9025 4.9 3.64C4.6225 2.8075 4.48 1.915 4.48 0.9925C4.48 0.5875 4.1425 0.25 3.7375 0.25H1.1425C0.7375 0.25 0.25 0.43 0.25 0.9925C0.25 7.96 6.0475 13.75 13.0075 13.75C13.54 13.75 13.75 13.2775 13.75 12.865V10.2775C13.75 9.8725 13.4125 9.535 13.0075 9.535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallWhiteIcon);
export default __webpack_public_path__ + "static/media/call-white-icon.cc580cad32e9145ec09c20e1efc8bcaf.svg";
export { ForwardRef as ReactComponent };